import { render, staticRenderFns } from "./WxcHome.vue?vue&type=template&id=5bc0ed70&"
import script from "./WxcHome.vue?vue&type=script&lang=js&"
export * from "./WxcHome.vue?vue&type=script&lang=js&"
import style0 from "./WxcHome.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports